/* Containers pop in as they scroll into view, each at a slightly different time.
   If this script or IntersectionObserver is unavailable, or the visitor prefers reduced motion,
   nothing is hidden and everything simply shows. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SEL = [
    '.card', '.panel', '.guide-card', '.pillars > div', '.faq .acc', '.info-card', '.rev',
    '.gallery figure', '.wall .tile', '.story-img', '.pdp-main', '.shopify-policy__container',
    '.buybar-in', '.specs', '.thumbs'
  ].join(',');

  var els = [].slice.call(document.querySelectorAll(SEL)).filter(function (e) {
    return !e.closest('.lb') && !e.closest('#toast') && !e.closest('.pop');
  });
  if (!els.length) return;

  els.forEach(function (e) { e.classList.add('pop'); });
  document.documentElement.classList.add('pop-on');

  var show = function (el, delay) {
    if (el.classList.contains('pop-in')) return;
    el.style.setProperty('--pd', delay + 'ms');
    el.classList.add('pop-in');
    setTimeout(function () { el.classList.add('pop-done'); }, delay + 1200);
  };

  var io = new IntersectionObserver(function (entries) {
    var vis = entries.filter(function (en) { return en.isIntersecting; }).map(function (en) { return en.target; });
    /* order what appears together by position, so a row pops in left to right, top to bottom */
    vis.sort(function (a, b) {
      var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
      return (Math.round(ra.top / 40) - Math.round(rb.top / 40)) || (ra.left - rb.left);
    });
    vis.forEach(function (el, i) {
      show(el, Math.min(i, 8) * 110 + Math.round(Math.random() * 60));
      io.unobserve(el);
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });

  els.forEach(function (e) { io.observe(e); });

  /* safety net: never leave anything hidden */
  setTimeout(function () { els.forEach(function (e) { show(e, 0); }); }, 5000);
})();
